{
  "pcs": ["MSCRTM", "NEPTUMAR", "EURONORDIC"],
  "localhost": ["CROSSOCEANRTM"],
  "kt": ["CROSSOCEANRTM", "MSCRTM"]
}
